export default "__VITE_ASSET__X7E25CzH__"